export const MS_TSD_ORG_NAME = 'ms-tsd';
export const ICM_REQUEST_URL = 'https://aka.ms/adocoreicmrequest';
const dev = {
    clientId: '8bae4996-5108-42bd-96d5-1d587d574c54',
    canvasClientId: '798b5903-519b-4f38-a40d-f40750e3939d',
    tenantId: '72f988bf-86f1-41af-91ab-2d7cd011db47',
    scopes: ['api://8bae4996-5108-42bd-96d5-1d587d574c54/access_as_user'],
    instrumentationKey: 'e69ec320-2a06-4e83-878b-05ab4ef067fa',
    extensionid: 'ADOCopilotPpe',
    publisherId: 'ADOCopilotPpe',
    AzureDevOpsScope: '499b84ac-1321-427f-aa17-267ca6975798/.default',
    GraphAPIScope: 'https://graph.microsoft.com/.default',
    graphTokenUrl: 'https://devopsassistantapippe.microsoft.com/tokengenerator/obo-token',
    adoSettingsUrl: 'https://devopsassistantapippe.microsoft.com/tokengenerator/app-token',
    getAreaPathsUrl: 'https://devopsassistantapippe.microsoft.com/tools/GetAreaPaths',
    getIterationPathsUrl: 'https://devopsassistantapippe.microsoft.com/tools/GetIterationPaths',
    getTeamsUrl: 'https://devopsassistantapippe.microsoft.com/tools/GetTeams',
    getMemoryConfigUrl: 'https://devopsassistantapippe.microsoft.com/tools/GetUserMemoryConfig',
    setMemoryConfigUrl: 'https://devopsassistantapippe.microsoft.com/tools/SetUserMemoryConfig',
    getMemoryConfigV2Url: 'https://devopsassistantapippe.microsoft.com/tools/GetUserMemoryConfigV2',
    setMemoryConfigV2Url: 'https://devopsassistantapippe.microsoft.com/tools/SetUserMemoryConfigV2',
    savePromptUrl: 'https://devopsassistantapippe.microsoft.com/tools/SavePrompt',
    getFeatureFlagsUrl: 'https://devopsassistantapippe.microsoft.com/tools/GetFeatureFlags',
    getSavedUserPromptsUrl: 'https://devopsassistantapippe.microsoft.com/tools/GetSavedUserPrompts',
    getPromptCategoriesUrl: 'https://devopsassistantapippe.microsoft.com/tools/GetPromptCategories',
    getPromptUrl: 'https://devopsassistantapippe.microsoft.com/tools/GetPrompt',
    getHeaderConfigUrl: 'https://devopsassistantapippe.microsoft.com/tools/GetHeaderConfig',
    deleteSavedPromptUrl: 'https://devopsassistantapippe.microsoft.com/tools/DeleteSavedPrompt',
    getSprintIterationUrl: 'https://devopsassistantapippe.microsoft.com/workitem/GetSprintIteration',
    getSprintCapacityUrl: 'https://devopsassistantapippe.microsoft.com/workitem/GetSprintCapacity',
    getSprintTeamSettingsUrl: 'https://devopsassistantapippe.microsoft.com/workitem/GetSprintTeamSettings',
    getSprintDependenciesUrl: 'https://devopsassistantapippe.microsoft.com/workitem/GetSprintDependencies',
    getSprintIterationByIdUrl: 'https://devopsassistantapippe.microsoft.com/workitem/GetSprintIterationById',
    wiqlQueryUrl: 'https://devopsassistantapippe.microsoft.com/workitem/WiqlQuery',
    getWorkItemTypeFieldsUrl: 'https://devopsassistantapippe.microsoft.com/workitem/GetWorkItemTypeFields',
    githubTokenLookupUrl: 'https://devopsassistantapippe.microsoft.com/ghcpagent/TokenLookup',
    chatStreamUrl: 'https://devopsassistantapippe.microsoft.com/ghcporchestrator/Chat',
    reverseSddBaseUrl: 'https://devopsassistantapippe.microsoft.com/reverse-sdd',
    sprintInsightsAnalyzeUrl: 'https://devopsassistantapippe.microsoft.com/ghcpagent/SprintInsights/Analyze',
    sprintInsightsAskAiUrl: 'https://devopsassistantapippe.microsoft.com/ghcpagent/SprintInsights/AskAI',
    queryInsightsAnalyzeUrl: 'https://devopsassistantapippe.microsoft.com/ghcpagent/QueryInsights/Analyze',
    queryInsightsAskAiUrl: 'https://devopsassistantapippe.microsoft.com/ghcpagent/QueryInsights/AskAI',
    onbordingStepsLink: 'https://dev.azure.com/msit-test1/',
    // Copilot Studio (Power Platform) connection settings. The MERGE Assistant/ADO
    // Copilot now connects via MSAL + CopilotStudioClient instead of a DirectLine
    // token endpoint. The host MSAL app (clientId above) brokers the Power Platform
    // token, so admin consent for the CopilotStudio.Copilots.Invoke permission must
    // be granted on the same app registration.
    copilotStudioEnvironmentId: '998d0e66-a964-eac2-a6dc-5a93bcbab005',
    copilotStudioAgentIdentifier: 'cre5c_adoCopilot',
    // OCV In-App Feedback Configurations
    inAppFeedback: 'ocv-inapp-feedback',
    feedbackClientName: 'AdoAiChat',
    defaultFeatureArea: 'AI Chat',
    cpsCallerAppHint: 'ADOAIChatPPE',
    feedbackAppId: 50455,
    feedbackForumUrl: '',
    feedbackPrivacyURL: 'https://privacy.microsoft.com/en-GB/privacy-in-our-products',
};
const prod = {
    clientId: 'fbff39c4-495a-4b37-8a03-85aaa475c993',
    canvasClientId: 'e0f227b8-4f46-445d-92b0-3ab33ca594a8',
    tenantId: '72f988bf-86f1-41af-91ab-2d7cd011db47',
    scopes: ['api://fbff39c4-495a-4b37-8a03-85aaa475c993/access_as_user'],
    instrumentationKey: '88afc016-93f6-45d5-b3bd-59667bc26684',
    extensionid: 'adoaichat',
    publisherId: 'MS-MSD-DEVXP',
    AzureDevOpsScope: '499b84ac-1321-427f-aa17-267ca6975798/.default',
    GraphAPIScope: 'https://graph.microsoft.com/.default',
    graphTokenUrl: 'https://devopsassistantapiprod.microsoft.com/tokengenerator/obo-token',
    adoSettingsUrl: 'https://devopsassistantapiprod.microsoft.com/tokengenerator/app-token',
    getAreaPathsUrl: 'https://devopsassistantapiprod.microsoft.com/tools/GetAreaPaths',
    getIterationPathsUrl: 'https://devopsassistantapiprod.microsoft.com/tools/GetIterationPaths',
    getTeamsUrl: 'https://devopsassistantapiprod.microsoft.com/tools/GetTeams',
    getMemoryConfigUrl: 'https://devopsassistantapiprod.microsoft.com/tools/GetUserMemoryConfig',
    setMemoryConfigUrl: 'https://devopsassistantapiprod.microsoft.com/tools/SetUserMemoryConfig',
    getMemoryConfigV2Url: 'https://devopsassistantapiprod.microsoft.com/tools/GetUserMemoryConfigV2',
    setMemoryConfigV2Url: 'https://devopsassistantapiprod.microsoft.com/tools/SetUserMemoryConfigV2',
    savePromptUrl: 'https://devopsassistantapiprod.microsoft.com/tools/SavePrompt',
    getFeatureFlagsUrl: 'https://devopsassistantapiprod.microsoft.com/tools/GetFeatureFlags',
    getSavedUserPromptsUrl: 'https://devopsassistantapiprod.microsoft.com/tools/GetSavedUserPrompts',
    getPromptCategoriesUrl: 'https://devopsassistantapiprod.microsoft.com/tools/GetPromptCategories',
    getPromptUrl: 'https://devopsassistantapiprod.microsoft.com/tools/GetPrompt',
    getHeaderConfigUrl: 'https://devopsassistantapiprod.microsoft.com/tools/GetHeaderConfig',
    deleteSavedPromptUrl: 'https://devopsassistantapiprod.microsoft.com/tools/DeleteSavedPrompt',
    getSprintIterationUrl: 'https://devopsassistantapiprod.microsoft.com/workitem/GetSprintIteration',
    getSprintCapacityUrl: 'https://devopsassistantapiprod.microsoft.com/workitem/GetSprintCapacity',
    getSprintTeamSettingsUrl: 'https://devopsassistantapiprod.microsoft.com/workitem/GetSprintTeamSettings',
    getSprintDependenciesUrl: 'https://devopsassistantapiprod.microsoft.com/workitem/GetSprintDependencies',
    getSprintIterationByIdUrl: 'https://devopsassistantapiprod.microsoft.com/workitem/GetSprintIterationById',
    wiqlQueryUrl: 'https://devopsassistantapiprod.microsoft.com/workitem/WiqlQuery',
    getWorkItemTypeFieldsUrl: 'https://devopsassistantapiprod.microsoft.com/workitem/GetWorkItemTypeFields',
    githubTokenLookupUrl: 'https://devopsassistantapiprod.microsoft.com/ghcpagent/TokenLookup',
    chatStreamUrl: 'https://devopsassistantapiprod.microsoft.com/ghcporchestrator/Chat',
    reverseSddBaseUrl: 'https://devopsassistantapiprod.microsoft.com/reverse-sdd',
    sprintInsightsAnalyzeUrl: 'https://devopsassistantapiprod.microsoft.com/ghcpagent/SprintInsights/Analyze',
    sprintInsightsAskAiUrl: 'https://devopsassistantapiprod.microsoft.com/ghcpagent/SprintInsights/AskAI',
    queryInsightsAnalyzeUrl: 'https://devopsassistantapiprod.microsoft.com/ghcpagent/QueryInsights/Analyze',
    queryInsightsAskAiUrl: 'https://devopsassistantapiprod.microsoft.com/ghcpagent/QueryInsights/AskAI',
    onbordingStepsLink: 'https://dev.azure.com/microsoftit/',
    // Copilot Studio (Power Platform) connection settings. See dev notes above.
    // TODO: confirm prod environmentId/agentIdentifier before shipping to prod.
    copilotStudioEnvironmentId: '50180b9f-399b-eaa5-a88c-7ee6e512610d',
    copilotStudioAgentIdentifier: 'cre5c_adoCopilot',
    // OCV In-App Feedback Configurations
    inAppFeedback: 'ocv-inapp-feedback',
    feedbackClientName: 'AdoAiChat',
    defaultFeatureArea: 'AI Chat',
    cpsCallerAppHint: 'ADOAIChatProd',
    feedbackAppId: 3008,
    feedbackForumUrl: '',
    feedbackPrivacyURL: 'https://privacy.microsoft.com/en-GB/privacy-in-our-products',
};
// HTTP Status Code - Error message Map
export const HTTP_ERROR_MESSAGES = {
    401: "You don’t have permission. Make sure you're signed in with the correct account. If you believe you should have access, contact support (https://aka.ms/adocoreicmrequest)",
    403: "You don’t have permission. Make sure you're signed in with the correct account. If you believe you should have access, contact support (https://aka.ms/adocoreicmrequest)",
};
export const PROMPT_SUGGESTION_LIMIT = 3;
export const FETCH_TIMEOUT_MS = 60000;
export const DEFAULT_HTTP_ERROR_MESSAGE = 'We couldn’t complete your request right now. Please try again in a few moments. If the issue persists, contact support (https://aka.ms/adocoreicmrequest)';
const env = process.env.NODE_ENV;
console.log('process.env.NODE_ENV:', env);
const envSettings = env === 'production' ? prod : dev;
export const config = {
    ...envSettings,
};
